import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withModifiers as _withModifiers, withCtx as _withCtx, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, createTextVNode as _createTextVNode } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_a_menu_item = _resolveComponent("a-menu-item")!
  const _component_a_space = _resolveComponent("a-space")!
  const _component_menu_tree_node = _resolveComponent("menu-tree-node", true)!
  const _component_a_sub_menu = _resolveComponent("a-sub-menu")!

  return (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.props.menuList, (item, index) => {
    return (_openBlock(), _createElementBlock(_Fragment, { key: index }, [
      (!item.children)
        ? (_openBlock(), _createBlock(_component_a_menu_item, {
            onClick: _withModifiers(($event: any) => (_ctx.handleClick(item.path)), ["stop"]),
            key: item.path,
            class: "menu"
          }, {
            default: _withCtx(() => [
              _createElementVNode("span", {
                class: _normalizeClass(item.selected ? 'user-select' : 'user-unselect')
              }, _toDisplayString(item.meta.title), 3)
            ]),
            _: 2
          }, 1032, ["onClick"]))
        : (item.type != 2)
          ? (_openBlock(), _createBlock(_component_a_sub_menu, {
              key: item.path
            }, {
              title: _withCtx(() => [
                _createVNode(_component_a_space, {
                  class: _normalizeClass([
            item.selected ? 'user-select' : 'user-unselect',
            !_ctx.props.collapsed ? 'sub-menu-' + _ctx.props.distanceIndex : '',
          ])
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("div", null, _toDisplayString(item.meta ? item.meta.title : ""), 1)
                  ]),
                  _: 2
                }, 1032, ["class"])
              ]),
              default: _withCtx(() => [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.children, (subitem) => {
                  return (_openBlock(), _createElementBlock(_Fragment, null, [
                    (!subitem.children && subitem.type != 2)
                      ? (_openBlock(), _createBlock(_component_a_menu_item, {
                          onClick: _withModifiers(($event: any) => (_ctx.handleClick(subitem.path)), ["stop"]),
                          key: subitem.path,
                          class: _normalizeClass(!_ctx.props.collapsed ? 'sub-item-' + _ctx.props.distanceIndex : '')
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_a_space, {
                              class: _normalizeClass(subitem.selected ? 'user-select' : 'user-unselect')
                            }, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(subitem.meta ? subitem.meta.title : ""), 1)
                              ]),
                              _: 2
                            }, 1032, ["class"])
                          ]),
                          _: 2
                        }, 1032, ["onClick", "class"]))
                      : (subitem.type != 2)
                        ? (_openBlock(), _createBlock(_component_menu_tree_node, {
                            menuList: [subitem],
                            onHandleClick: _ctx.handleClick,
                            key: subitem.path,
                            distanceIndex: _ctx.props.distanceIndex + 1,
                            collapsed: _ctx.props.collapsed
                          }, null, 8, ["menuList", "onHandleClick", "distanceIndex", "collapsed"]))
                        : _createCommentVNode("", true)
                  ], 64))
                }), 256))
              ]),
              _: 2
            }, 1024))
          : _createCommentVNode("", true)
    ], 64))
  }), 128))
}